export default "<!--parent-settings-component-->\n<ng-template #component></ng-template>\n"